// ── Edit your details here ─────────────────────────────────────────────────
// Everything the personal site shows about you lives in this one file.
// Empty strings ('') are simply not shown, so fill in what you have and leave
// the rest blank. Items marked TODO are guesses/placeholders — please correct.

export const profile = {
  name: 'Fabian Morelli',
  role: 'PhD Student in Machine Learning',
  affiliation: 'KTH Royal Institute of Technology, Stockholm',
  tagline: 'Model merging & mechanistic interpretability',

  // profile photo shown in the hero (drop an image in public/ and point here)
  photo: '/fabian.jpg',

  bio:
    "I'm a PhD student in machine learning supervised by Sebastian Dalleiger and Aris Gionis, working on model merging and pruning. I'm " +
    "interested in how separately trained networks can be combined into one or how individual models can be made more efficient by reducing the parameter count. " +
    "I want to better understand what merging, fine-tuning and compression do to a model's internal " +
    "representations. I study how the architecture and training procedures of the " +
    "individual models influence the merging quality of different methods.",

  // shown as a row of links on the home page (blank ones are hidden)
  email: 'research@fabianmorelli.de',
  links: {
    scholar: 'https://scholar.google.com/citations?user=es00BbgAAAAJ',
    github: 'https://github.com/Fabian-Mor',
    linkedin: '',                             // TODO
    twitter: '',                              // TODO (x.com/…)
  },

  // optional: drop a CV PDF into public/cv.pdf and set this to '/cv.pdf'
  cvPdf: '',
};

export default profile;
